import * as CombosReducer from './comboReducer';
import * as VehicleListReducer from './vehicleListReducer';
import * as CombosReportReducer from './combosReportData';

const Reducers = {
  ...CombosReducer,
  ...VehicleListReducer,
  ...CombosReportReducer,
};

export default Reducers;
